module.exports = __webpack_public_path__ + "static/media/3.851597a0.gif";